import { render, staticRenderFns } from "./h-banner.vue?vue&type=template&id=94e98854&scoped=true"
import script from "./h-banner.vue?vue&type=script&lang=js"
export * from "./h-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e98854",
  null
  
)

export default component.exports